import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANG } from '../i18n/lang.config';

/**
 * localize
 * Prefija un routerLink con el idioma activo para que la navegación interna
 * se mantenga dentro del mismo idioma.
 *
 * Uso en plantillas:
 *   <a [routerLink]="'/products' | localize">…</a>
 *   <a [routerLink]="['/about'] | localize" [queryParams]="…">…</a>
 *
 * Resultado: ['/', 'de', 'products']  ->  /de/products
 *
 * Es impure porque el idioma activo puede cambiar en tiempo de ejecución.
 */
@Pipe({ name: 'localize', pure: false })
export class LocalizePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(link: string | any[]): any[] {
    const lang = this.translate.currentLang || this.translate.getDefaultLang() || DEFAULT_LANG;
    const segments: any[] = [];

    const push = (value: any) => {
      if (typeof value === 'string') {
        value.split('/').forEach(part => {
          if (part) { segments.push(part); }
        });
      } else {
        segments.push(value);
      }
    };

    if (Array.isArray(link)) {
      link.forEach(push);
    } else {
      push(link);
    }

    return ['/', lang, ...segments];
  }
}
